import { http } from "@/utils/http";
export const getGear = (params) => {

    console.log(params)
  // 预约档位
  return http({ url: `/1/reservation/gear/`, method: "GET", params: params });
};


